module.exports = __webpack_public_path__ + "static/media/fvs_valve1_107.88f3bb41.jpg";